import React from 'react';
import './EmptyState.css';

/**
 * Shared EmptyState Component
 *
 * Consistent placeholder shown when a list is empty: icon + message +
 * optional hint and/or CTA button. Adopts the visual style established
 * in GemeenschappenPage's original empty state.
 *
 * @param {string} icon - Optional emoji icon (e.g. 🏠, 👥, 📅)
 * @param {string} message - Required primary message
 * @param {string} hint - Optional secondary line
 * @param {string} actionLabel - Optional CTA button label
 * @param {Function} onAction - Optional CTA button handler
 */
const EmptyState = ({ icon, message, hint, actionLabel, onAction }) => (
  <div className="empty-state" role="status">
    {icon && <div className="placeholder-icon">{icon}</div>}
    <p>{message}</p>
    {hint && <p className="hint">{hint}</p>}
    {actionLabel && onAction && (
      <button className="add-button empty-state-action" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;